import React from "react"
import { FormControl, FormLabel, RadioGroup } from "@material-ui/core"
import { fieldPropTypes } from "redux-form"
import PropTypes from "prop-types"

export default function FieldRadioGroup({
  input: { value, onChange, ...input },
  label,
  children,
  ...rest
}) {
  return (
    <FormControl {...input} {...rest}>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <RadioGroup value={value} onChange={onChange}>
        {children}
      </RadioGroup>
    </FormControl>
  )
}

FieldRadioGroup.propTypes = {
  ...fieldPropTypes,
  label: PropTypes.string
}

FieldRadioGroup.defaultProps = {
  label: undefined
}
